// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headerTitle_root__2cexF {\n  display: flex;\n  align-items: center;\n  margin-top: 30px;\n  border-bottom: 1px solid #eef2f4;\n  display: grid;\n  grid-template-columns: 3fr 100px 95px; }\n  .headerTitle_root__2cexF .headerTitle_headerIteam__1FEi7 {\n    -webkit-user-select: none;\n            user-select: none;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    color: #464646; }\n    .headerTitle_root__2cexF .headerTitle_headerIteam__1FEi7:nth-of-type(3) {\n      text-align: right;\n      padding-right: 50px;\n      box-sizing: border-box; }\n", ""]);
// Exports
exports.locals = {
	"root": "headerTitle_root__2cexF",
	"headerIteam": "headerTitle_headerIteam__1FEi7"
};
module.exports = exports;
